define('SageDotCom/DataLayer/Global/search',['jquery',
        'SageDotCom/DataLayer/tealium',
        'SageDotCom/DataLayer/Events/searchInteraction',
        'SageDotCom/DataLayer/Events/searchRefinement',
        'SageDotCom/DataLayer/Events/searchSelection',
        'eventManager',
        'score_bootstrap/Utils/UrlHelper'],
    function ($, tealium, interactionEvent, refinementEvent, selectionEvent, eventManager, urlHelper) {
        function searchTracking() {}

        var getFacets = function (facet) {
            var searchFacets = urlHelper.getUrlParameters(window.location, facet)[0] || '(reset)';

            searchFacets = searchFacets.replace(/\,/g, '; ');
            searchFacets = searchFacets.replace(/[f]\./g, '');
            searchFacets = searchFacets.replace(/\|(.*?)\:/g, ': ');

            return searchFacets;
        }

        var getTerm = function (term) {
            return urlHelper.getUrlParameters(window.location, term)[0] || '';
        }

        searchTracking.prototype.initialize = function initialize() {

            eventManager.subscribe("search-triggered", function(scope, term, resultPage) {
                var eventObj = interactionEvent.GenerateEventMetadata(scope, term, resultPage || window.location.href);
                tealium.event(eventObj);
            });

            eventManager.subscribe("search-triggered-suggested", function (scope, term, resultPage) {
                var eventObj = selectionEvent.GenerateEventMetadata(scope, term, null, "Search-suggested", "search", "search_int", resultPage || window.location.href);
                tealium.event(eventObj);
            });
            // refinement happens on page alongside the results, so we need to pluck term out of the URL
            // also, to see full list of refinements we need to check the URL for searchfacets param
            eventManager.subscribe("funnelback-facet-refinement", function (scope) {
                var searchTerm = getTerm("searchterm");
                var searchFacets = getFacets("searchfacets");

                var eventObj = refinementEvent.GenerateEventMetadata(scope, searchTerm, searchFacets, window.location.href);
                tealium.event(eventObj);
            });

            eventManager.subscribe("funnelback-results-rendered", function(scope) {
                $(".result a", scope).click(function (event) {
                    var searchTerm = getTerm("searchterm");
                    var searchFacets = getFacets("searchfacets");

                    var eventObj = selectionEvent.GenerateEventMetadata(event.currentTarget, searchTerm, searchFacets);
                    tealium.event(eventObj);
                });

                $(".best-bet a", scope).click(function (event) {
                    var searchTerm = getTerm("searchterm") + " (suggested product)";
                    var searchFacets = getFacets("searchfacets");

                    var eventObj = selectionEvent.GenerateEventMetadata(event.currentTarget, searchTerm, searchFacets);
                    tealium.event(eventObj);
                });

                // var eventObj = selectionEvent.GenerateEventMetadata(scope, searchTerm, searchFacets);
            });

            eventManager.subscribe("facet-selected", function (scope, term, key, value) {
                var facet = key + ": ";

                if (!value) {
                    value = urlHelper.getUrlParameters(window.location, "keywords")[0] || '(not set)';
                }

                if (Array.isArray(value)) {
                    value.forEach(function (elem) {
                        facet += elem + ";";
                    });
                }
                else if (value) {
                    facet += value;
                }

                var eventObj = refinementEvent.GenerateEventMetadata(scope, term, facet, window.location.href);
                tealium.event(eventObj);
            });

            eventManager.subscribe("search-result-selected", function (scope, term, facets, label) {
                var eventObj = selectionEvent.GenerateEventMetadata(scope, term, facets, label);
                tealium.event(eventObj);
            });

        }

        return new searchTracking();
    });
